export const languages = {
  Pt: {
    language_label: "Idioma",
    theme_light: "Claro",
    theme_dark: "Escuro",
    light_theme: "Tema claro",
    dark_theme: "Tema escuro",
    loading: "Carregando...",
    loading_data: "Carregando dados",
    external_camera_loading_hint: "Preparando o acesso da câmera externa.",
    open_in_chrome_title: "Abra pelo Google Chrome",
    open_in_chrome_hint: "Para evitar bloqueios de câmera, use o Chrome neste dispositivo.",
    open_in_chrome: "Abrir no Chrome",
    external_camera_access: "Câmera externa",
    choose_institution: "Escolha a instituição",
    choose_institution_hint: "Selecione a instituição para conectar a câmera externa ao ambiente do candidato.",
    access_external_camera: "Acessar câmera externa",
    no_institution_available: "Nenhuma instituição disponível",
    try_again_later: "Tente novamente mais tarde.",
    welcome: "Bem-vindo!",
    login_subtitle: "Faça login para conectar a câmera externa ao processo seletivo.",
    cpf_or_email: "CPF ou E-mail",
    cpf: "CPF",
    email: "E-mail",
    password: "Senha",
    enter: "Entrar",
    entering: "Entrando...",
    server_response_error: "Erro ao pegar resposta do servidor",
    internet_connection_error: "Erro ao pegar resposta do servidor. Você está conectado à internet?",
    external_camera_hero_label: "Monitoramento complementar",
    external_camera_hero_title: "Conecte este dispositivo como câmera externa.",
    external_camera_hero_hint: "Mantenha o aparelho carregado, estável e posicionado para acompanhar o ambiente durante a avaliação.",
    candidate: "Candidato",
    logout: "Sair",
    notice: "Aviso",
    no_process_linked: "Este usuário não está vinculado a nenhum processo seletivo.",
    candidate_name: "Nome do candidato",
    device_preparation: "Preparação do dispositivo",
    institution_logo: "Logo da instituição",
    camera_permission_title: "Permissões necessárias",
    camera_permission_hint: "Compartilhe a câmera e o microfone clicando no botão abaixo.",
    sharing_complete_title: "Compartilhamento concluído",
    sharing_complete_hint: "Avance clicando no botão de aceitar termos e conceder permissões.",
    external_camera_label: "Câmera externa",
    change_camera: "Alterar câmera",
    camera_option: "Câmera {number}",
    access_requirements: "Requisitos para acesso",
    complete_items_to_continue: "Complete os itens abaixo para avançar.",
    video_sharing: "Compartilhamento de vídeo",
    audio_sharing: "Compartilhamento de áudio",
    attention: "Atenção",
    request_camera_microphone_permissions: "Solicitar permissões de câmera e microfone",
    requesting_permissions: "Solicitando permissões...",
    accept_terms_permissions: "Aceitar termos e conceder permissões",
    media_not_found: "Nenhuma câmera ou microfone conectado ao seu computador foi reconhecido. Verifique se ambos estão conectados e ativados em seu dispositivo e tente novamente.",
    camera_permission_denied: "Você bloqueou seu acesso à câmera. Para liberá-lo, vá nas configurações do seu navegador.",
    external_camera_page_hint: "Use este dispositivo como câmera complementar durante a avaliação.",
    process: "Processo seletivo",
    start_time: "Hora de início",
    end_time: "Hora de encerramento",
    process_start_time: "Hora de início do processo",
    process_end_time: "Hora de encerramento do processo",
    started_at: "Iniciado em",
    finishes_at: "Finaliza em",
    evaluation_description: "Descrição da avaliação",
    updating_process_status: "Atualizando o status do processo.",
    loading_information: "Carregando informações...",
    no_face_detected: "Nenhum rosto detectado. Mude a posição da câmera ou altere o dispositivo.",
    multiple_faces_detected: "Mais de um rosto detectado. Para entrar na avaliação você deve estar em um ambiente sozinho.",
    center_face: "Centralize o rosto na câmera para ser detectado",
    turn_right: "Vire seu rosto para o lado direito",
    turn_left: "Vire seu rosto para o lado esquerdo",
    speak_to_validate_microphone: "Fale alto a frase \"Estou aqui\" para validar seu microfone",
    device_validation_done: "Validação de dispositivo concluída - Clique no botão abaixo para prosseguir",
    join_queue: "Entrar na fila",
    unstable_connection: "Conexão instável",
    wait_reconnect: "Aguarde a reconexão para continuar.",
    wait_release: "Aguarde a liberação.",
    other_window_open: "Você já possui uma outra janela deste sistema aberta. Feche-a e atualize esta página para continuar.",
    external_camera_session_active_title: "Câmera externa já aberta",
    external_camera_session_active_hint: "Este módulo já está ativo em outra aba ou janela. Feche a outra aba e atualize esta página para continuar.",
    reload_page: "Atualizar página",
    cannot_continue: "Não foi possível continuar",
    back: "Voltar",
    two_screens_blocked: "Não é permitido usar duas telas durante a avaliação",
    time_to_start: "Tempo para começar:",
    interview_queue: "Você está na fila para a entrevista",
    queue_position: "Posição",
    entering_interview_queue: "Entrando na fila para entrevista...",
    join_interview_queue: "Entrar na fila para a entrevista",
    in_queue: "Você está na fila",
    exam_starts_after_access: "O tempo de prova iniciará após o acesso. Tempo de prova após iniciar: {minutes} min",
    entering_queue: "Entrando na fila...",
    close: "Fechar",
    start: "Iniciar",
    evaluation_finished_success: "Avaliação finalizada com sucesso",
    external_camera_disconnected: "A câmera externa foi desconectada deste processo.",
    click_here_to_exit: "Clique aqui para sair"
  },
  En: {
    language_label: "Language",
    theme_light: "Light",
    theme_dark: "Dark",
    light_theme: "Light theme",
    dark_theme: "Dark theme",
    loading: "Loading...",
    loading_data: "Loading data",
    external_camera_loading_hint: "Preparing external camera access.",
    open_in_chrome_title: "Open in Google Chrome",
    open_in_chrome_hint: "To avoid camera restrictions, use Chrome on this device.",
    open_in_chrome: "Open in Chrome",
    external_camera_access: "External camera",
    choose_institution: "Choose the institution",
    choose_institution_hint: "Select the institution to connect the external camera to the candidate environment.",
    access_external_camera: "Open external camera",
    no_institution_available: "No institution available",
    try_again_later: "Try again later.",
    welcome: "Welcome!",
    login_subtitle: "Sign in to connect the external camera to the selection process.",
    cpf_or_email: "CPF or email",
    cpf: "CPF",
    email: "Email",
    password: "Password",
    enter: "Sign in",
    entering: "Signing in...",
    server_response_error: "Error reading the server response",
    internet_connection_error: "Error reading the server response. Are you connected to the internet?",
    external_camera_hero_label: "Complementary monitoring",
    external_camera_hero_title: "Connect this device as an external camera.",
    external_camera_hero_hint: "Keep the device charged, stable, and positioned to monitor the environment during the evaluation.",
    candidate: "Candidate",
    logout: "Log out",
    notice: "Notice",
    no_process_linked: "This user is not linked to any selection process.",
    candidate_name: "Candidate name",
    device_preparation: "Device preparation",
    institution_logo: "Institution logo",
    camera_permission_title: "Permissions required",
    camera_permission_hint: "Share camera and microphone using the button below.",
    sharing_complete_title: "Sharing complete",
    sharing_complete_hint: "Continue by clicking the accept terms and grant permissions button.",
    external_camera_label: "External camera",
    change_camera: "Change camera",
    camera_option: "Camera {number}",
    access_requirements: "Access requirements",
    complete_items_to_continue: "Complete the items below to continue.",
    video_sharing: "Video sharing",
    audio_sharing: "Audio sharing",
    attention: "Attention",
    request_camera_microphone_permissions: "Request camera and microphone permissions",
    requesting_permissions: "Requesting permissions...",
    accept_terms_permissions: "Accept terms and grant permissions",
    media_not_found: "No camera or microphone connected to your computer was detected. Check that both are connected and enabled on your device and try again.",
    camera_permission_denied: "You blocked camera access. Enable it in your browser settings.",
    external_camera_page_hint: "Use this device as a complementary camera during the evaluation.",
    process: "Selection process",
    start_time: "Start time",
    end_time: "End time",
    process_start_time: "Process start time",
    process_end_time: "Process end time",
    started_at: "Started at",
    finishes_at: "Finishes at",
    evaluation_description: "Evaluation description",
    updating_process_status: "Updating process status.",
    loading_information: "Loading information...",
    no_face_detected: "No face detected. Change the camera position or device.",
    multiple_faces_detected: "More than one face detected. To enter the evaluation, you must be alone in the environment.",
    center_face: "Center your face in the camera to be detected",
    turn_right: "Turn your face to the right",
    turn_left: "Turn your face to the left",
    speak_to_validate_microphone: "Say \"I am here\" out loud to validate your microphone",
    device_validation_done: "Device validation complete - Click the button below to continue",
    join_queue: "Join queue",
    unstable_connection: "Unstable connection",
    wait_reconnect: "Wait for reconnection to continue.",
    wait_release: "Wait for approval.",
    other_window_open: "You already have another window of this system open. Close it and refresh this page to continue.",
    external_camera_session_active_title: "External camera already open",
    external_camera_session_active_hint: "This module is already active in another tab or window. Close the other tab and refresh this page to continue.",
    reload_page: "Reload page",
    cannot_continue: "Could not continue",
    back: "Back",
    two_screens_blocked: "Using two screens during the evaluation is not allowed",
    time_to_start: "Time to start:",
    interview_queue: "You are in the interview queue",
    queue_position: "Position",
    entering_interview_queue: "Joining the interview queue...",
    join_interview_queue: "Join interview queue",
    in_queue: "You are in the queue",
    exam_starts_after_access: "The exam timer will start after access. Exam time after starting: {minutes} min",
    entering_queue: "Joining queue...",
    close: "Close",
    start: "Start",
    evaluation_finished_success: "Evaluation completed successfully",
    external_camera_disconnected: "The external camera has been disconnected from this process.",
    click_here_to_exit: "Click here to exit"
  },
  Es: {
    language_label: "Idioma",
    theme_light: "Claro",
    theme_dark: "Oscuro",
    light_theme: "Tema claro",
    dark_theme: "Tema oscuro",
    loading: "Cargando...",
    loading_data: "Cargando datos",
    external_camera_loading_hint: "Preparando el acceso de la cámara externa.",
    open_in_chrome_title: "Abre en Google Chrome",
    open_in_chrome_hint: "Para evitar bloqueos de cámara, usa Chrome en este dispositivo.",
    open_in_chrome: "Abrir en Chrome",
    external_camera_access: "Cámara externa",
    choose_institution: "Elige la institución",
    choose_institution_hint: "Selecciona la institución para conectar la cámara externa al ambiente del candidato.",
    access_external_camera: "Acceder a la cámara externa",
    no_institution_available: "Ninguna institución disponible",
    try_again_later: "Inténtalo nuevamente más tarde.",
    welcome: "¡Bienvenido!",
    login_subtitle: "Inicia sesión para conectar la cámara externa al proceso selectivo.",
    cpf_or_email: "CPF o email",
    cpf: "CPF",
    email: "Email",
    password: "Contraseña",
    enter: "Entrar",
    entering: "Entrando...",
    server_response_error: "Error al obtener la respuesta del servidor",
    internet_connection_error: "Error al obtener la respuesta del servidor. ¿Estás conectado a internet?",
    external_camera_hero_label: "Monitoreo complementario",
    external_camera_hero_title: "Conecta este dispositivo como cámara externa.",
    external_camera_hero_hint: "Mantén el dispositivo cargado, estable y posicionado para monitorear el ambiente durante la evaluación.",
    candidate: "Candidato",
    logout: "Salir",
    notice: "Aviso",
    no_process_linked: "Este usuario no está vinculado a ningún proceso selectivo.",
    candidate_name: "Nombre del candidato",
    device_preparation: "Preparación del dispositivo",
    institution_logo: "Logo de la institución",
    camera_permission_title: "Permisos necesarios",
    camera_permission_hint: "Comparte la cámara y el micrófono haciendo clic en el botón de abajo.",
    sharing_complete_title: "Compartición concluida",
    sharing_complete_hint: "Avanza haciendo clic en el botón de aceptar términos y conceder permisos.",
    external_camera_label: "Cámara externa",
    change_camera: "Cambiar cámara",
    camera_option: "Cámara {number}",
    access_requirements: "Requisitos de acceso",
    complete_items_to_continue: "Completa los elementos de abajo para avanzar.",
    video_sharing: "Compartición de video",
    audio_sharing: "Compartición de audio",
    attention: "Atención",
    request_camera_microphone_permissions: "Solicitar permisos de cámara y micrófono",
    requesting_permissions: "Solicitando permisos...",
    accept_terms_permissions: "Aceptar términos y conceder permisos",
    media_not_found: "No se detectó ninguna cámara o micrófono conectado a tu computador. Verifica que ambos estén conectados y activados en tu dispositivo e inténtalo nuevamente.",
    camera_permission_denied: "Bloqueaste el acceso a la cámara. Para habilitarlo, ve a la configuración de tu navegador.",
    external_camera_page_hint: "Usa este dispositivo como cámara complementaria durante la evaluación.",
    process: "Proceso selectivo",
    start_time: "Hora de inicio",
    end_time: "Hora de finalización",
    process_start_time: "Hora de inicio del proceso",
    process_end_time: "Hora de finalización del proceso",
    started_at: "Iniciado en",
    finishes_at: "Finaliza en",
    evaluation_description: "Descripción de la evaluación",
    updating_process_status: "Actualizando el estado del proceso.",
    loading_information: "Cargando información...",
    no_face_detected: "No se detectó ningún rostro. Cambia la posición de la cámara o el dispositivo.",
    multiple_faces_detected: "Se detectó más de un rostro. Para entrar en la evaluación, debes estar solo en el ambiente.",
    center_face: "Centra tu rostro en la cámara para ser detectado",
    turn_right: "Gira tu rostro hacia la derecha",
    turn_left: "Gira tu rostro hacia la izquierda",
    speak_to_validate_microphone: "Di en voz alta \"Estoy aquí\" para validar tu micrófono",
    device_validation_done: "Validación del dispositivo concluida - Haz clic en el botón de abajo para continuar",
    join_queue: "Entrar en la fila",
    unstable_connection: "Conexión inestable",
    wait_reconnect: "Espera la reconexión para continuar.",
    wait_release: "Espera la autorización.",
    other_window_open: "Ya tienes otra ventana de este sistema abierta. Ciérrala y actualiza esta página para continuar.",
    external_camera_session_active_title: "Cámara externa ya abierta",
    external_camera_session_active_hint: "Este módulo ya está activo en otra pestaña o ventana. Cierra la otra pestaña y actualiza esta página para continuar.",
    reload_page: "Actualizar página",
    cannot_continue: "No fue posible continuar",
    back: "Volver",
    two_screens_blocked: "No está permitido usar dos pantallas durante la evaluación",
    time_to_start: "Tiempo para comenzar:",
    interview_queue: "Estás en la fila para la entrevista",
    queue_position: "Posición",
    entering_interview_queue: "Entrando en la fila para entrevista...",
    join_interview_queue: "Entrar en la fila para la entrevista",
    in_queue: "Estás en la fila",
    exam_starts_after_access: "El tiempo de prueba iniciará después del acceso. Tiempo de prueba después de iniciar: {minutes} min",
    entering_queue: "Entrando en la fila...",
    close: "Cerrar",
    start: "Iniciar",
    evaluation_finished_success: "Evaluación finalizada con éxito",
    external_camera_disconnected: "La cámara externa fue desconectada de este proceso.",
    click_here_to_exit: "Haz clic aquí para salir"
  }
};

export const languageOptions = [
  { value: 'Pt', label: 'Português' },
  { value: 'En', label: 'English' },
  { value: 'Es', label: 'Español' },
];

export function getSelectedLanguage() {
  const selected = localStorage.getItem('external_camera_language') || 'Pt';
  return languages[selected] ? selected : 'Pt';
}

export function setSelectedLanguage(language) {
  const selected = languages[language] ? language : 'Pt';
  localStorage.setItem('external_camera_language', selected);
  window.dispatchEvent(new CustomEvent('external_camera_language_change', { detail: selected }));
  return selected;
}

export function getLanguageTexts(language = getSelectedLanguage()) {
  return languages[language] || languages.Pt;
}

export function formatLanguageText(text, values = {}) {
  return String(text || '').replace(/\{(\w+)\}/g, (_, key) => values[key] ?? '');
}
